import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConfigService } from "@master/core/dist/core";
import { config } from "@config/config";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})

export class SendMailService extends BaseService{
  constructor(
    private http: HttpClient,
    public appConfigService: AppConfigService
  ) {
    super(appConfigService);
  } 
  
sendMail(params: any): Observable<any> {
    const configUrl = this.getUrl() + '/notifications/send-new-prevision-mail';
    // tslint:disable-next-line:max-line-length
    return this.http.post( configUrl, {
      qr: params.qr,
      email: params.email,
      TKNUM: params.TKNUM,
      VBELN: params.VBELN,
      date: params.date,
    });
  }

  /**
   * MYTA MADERUELO IMPLEMENTATION
   * @param params 
   * @returns 
   */
  sendSlotWarningMail(params: any): Observable<any> {
    const configUrl = this.getUrl() + '/notifications/send-slot-warning-mail';
    // tslint:disable-next-line:max-line-length
    return this.http.post( configUrl, {
      qr: params.qr,
      email: params.email,
      TKNUM: params.TKNUM,
      DPLBG: params.DPLBG,
      slot: params.slot? params.slot: undefined
    });
  }
}
